<div class="message-container">
  <div class="banner" [class]="type.toLowerCase()">
    {{message}}
  </div>
</div>
